import { Grid, Typography } from '@mui/material';
import { Control, UseFormRegister } from 'react-hook-form';
import { QuestionsForm } from './QuestionsForm';

interface QuestionsProps {  
    control: Control<any>
}
export const Questions = ( { control }: QuestionsProps ) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={"flex"} flexDirection={"column"}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Provide questions for applicants</Typography> 
            <Typography variant='body-medium' color={'primary'} >List any specific questions you want to ask applicants when they apply. You can see their answers when you receive their application.</Typography>
            <QuestionsForm control={control}/>
        </Grid>
    )
}